/**
 * Fontes disponíveis para o mini-site, agrupadas como o cliente pensa
 * ("moderna", "elegante", "com impacto") — não por classificação tipográfica.
 * Todas são Google Fonts, carregadas no layout.
 */

export const FONTES = [
  { grupo: 'Modernas (sem serifa)', itens: [
    { id: 'inter',    nome: 'Inter',             css: "'Inter',sans-serif" },
    { id: 'outfit',   nome: 'Outfit',            css: "'Outfit',sans-serif" },
    { id: 'poppins',  nome: 'Poppins',           css: "'Poppins',sans-serif" },
    { id: 'montserrat', nome: 'Montserrat',      css: "'Montserrat',sans-serif" },
    { id: 'dmsans',   nome: 'DM Sans',           css: "'DM Sans',sans-serif" },
    { id: 'manrope',  nome: 'Manrope',           css: "'Manrope',sans-serif" },
    { id: 'jakarta',  nome: 'Plus Jakarta Sans', css: "'Plus Jakarta Sans',sans-serif" },
    { id: 'figtree',  nome: 'Figtree',           css: "'Figtree',sans-serif" },
    { id: 'worksans', nome: 'Work Sans',         css: "'Work Sans',sans-serif" },
    { id: 'nunito',   nome: 'Nunito',            css: "'Nunito',sans-serif" },
    { id: 'rubik',    nome: 'Rubik',             css: "'Rubik',sans-serif" },
    { id: 'raleway',  nome: 'Raleway',           css: "'Raleway',sans-serif" },
    { id: 'space',    nome: 'Space Grotesk',     css: "'Space Grotesk',sans-serif" },
    { id: 'sora',     nome: 'Sora',              css: "'Sora',sans-serif" },
  ]},
  { grupo: 'Elegantes (com serifa)', itens: [
    { id: 'playfair', nome: 'Playfair Display',  css: "'Playfair Display',Georgia,serif" },
    { id: 'fraunces', nome: 'Fraunces',          css: "'Fraunces',Georgia,serif" },
    { id: 'dmserif',  nome: 'DM Serif Display',  css: "'DM Serif Display',Georgia,serif" },
    { id: 'lora',     nome: 'Lora',              css: "'Lora',Georgia,serif" },
    { id: 'cormorant',nome: 'Cormorant Garamond',css: "'Cormorant Garamond',Georgia,serif" },
    { id: 'merri',    nome: 'Merriweather',      css: "'Merriweather',Georgia,serif" },
    { id: 'baskerville', nome: 'Libre Baskerville', css: "'Libre Baskerville',Georgia,serif" },
  ]},
  { grupo: 'Com impacto', itens: [
    { id: 'bebas',    nome: 'Bebas Neue',        css: "'Bebas Neue',Impact,sans-serif" },
    { id: 'anton',    nome: 'Anton',             css: "'Anton',Impact,sans-serif" },
    { id: 'archivo',  nome: 'Archivo Black',     css: "'Archivo Black',Impact,sans-serif" },
    { id: 'oswald',   nome: 'Oswald',            css: "'Oswald',sans-serif" },
  ]},
  { grupo: 'Manuscritas', itens: [
    { id: 'pacifico', nome: 'Pacifico',          css: "'Pacifico',cursive" },
    { id: 'dancing',  nome: 'Dancing Script',    css: "'Dancing Script',cursive" },
    { id: 'caveat',   nome: 'Caveat',            css: "'Caveat',cursive" },
  ]},
];

export const TODAS_FONTES = FONTES.flatMap(g => g.itens);
export const acharFonte = (css) => TODAS_FONTES.find(f => f.css === css);

/** URL única com todas as famílias (evita várias requisições). */
export const GOOGLE_FONTS_URL =
  'https://fonts.googleapis.com/css2?' + [
    'family=Inter:wght@400;500;600;700;800;900',
    'family=Outfit:wght@400;600;700;800',
    'family=Poppins:wght@400;600;700;800',
    'family=Montserrat:wght@400;600;700;800',
    'family=DM+Sans:wght@400;500;700',
    'family=Manrope:wght@400;600;700;800',
    'family=Plus+Jakarta+Sans:wght@400;600;700;800',
    'family=Figtree:wght@400;600;700;800',
    'family=Work+Sans:wght@400;600;700',
    'family=Nunito:wght@400;600;700;800',
    'family=Rubik:wght@400;600;700',
    'family=Raleway:wght@400;600;700;800',
    'family=Space+Grotesk:wght@400;500;600;700',
    'family=Sora:wght@400;600;700;800',
    'family=Playfair+Display:wght@500;600;700;800',
    'family=Fraunces:opsz,wght@9..144,500;9..144,600;9..144,700',
    'family=DM+Serif+Display',
    'family=Lora:wght@500;600;700',
    'family=Cormorant+Garamond:wght@600;700',
    'family=Merriweather:wght@400;700',
    'family=Libre+Baskerville:wght@400;700',
    'family=Bebas+Neue',
    'family=Anton',
    'family=Archivo+Black',
    'family=Oswald:wght@400;500;600;700',
    'family=Pacifico',
    'family=Dancing+Script:wght@600;700',
    'family=Caveat:wght@600;700',
  ].join('&') + '&display=swap';
